<template>
  <div>
    <a-spin :spinning="spinning">
      <a-form :form="form">
        <a-form-item label="序号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number
            :max="10000"
            :min="1"
            v-decorator="['serial', {rules: [{ required: false, message: '请输入' }]}]" />
        </a-form-item>
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['name', {rules: [{required: true, message: '请输入'}]}]" />
        </a-form-item>
        <a-form-item label="图片路径" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
          <a-input v-decorator="['picture', {rules: [{required: true, message: '请输入'}]}]" />
        </a-form-item>
        <a-form-item label="图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <div class="clearfix" style="display: inline-block">
            <a-upload
              v-decorator="['pictures', {rules: [{required: true, message: '请输入'}]}]"
              name="file"
              accept="image/png, image/jpeg, image/jpg"
              :action="actionUrl"
              list-type="picture-card"
              :file-list="fileList"
              :data="new_multipart_params"
              :before-upload="beforeUpload"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">
                  修改图片上传
                </div>
              </div>
            </a-upload>
            <span>提示：图片宽高比为2:1</span>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </a-form-item>
        <a-form-item label="连接" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['link', {rules: [{required: false, message: '请输入'}]}]" />
          <a-tooltip placement="top">
            <template slot="title">
              <p>商品详情：/pages/product/product?barcode=123456</p>
              <p>分类：/pages/product/list?category=010301</p>
              <p>多分类：/pages/product/list?category=010301,010302,010303</p>
            </template>
            <p style="border: 1px solid #ffa39e; padding-left: 10px; border-radius: 5px; background-color: #fff1f0"><a-icon type="info-circle" :style="{ fontSize: '14px', color: '#ff3311' }"/> 示例</p>
          </a-tooltip>
        </a-form-item>
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-switch v-decorator="['is_show', { valuePropName: 'checked' }]" />
        </a-form-item>
        <a-form-item
          v-bind="buttonCol"
        >
          <a-row>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </a-spin>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { customUploadFileName, ossToken } from '@/utils/util'
const { editBanner } = require('@/api/applet_banner')
const fields = ['name', 'link', 'picture', 'serial', 'is_show', 'pictures']
function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  name: 'GoodsEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      spinning: true,
      previewVisible: false,
      previewVisible2: false,
      actionUrl: '',
      fileList: [],
      fileList2: [],
      parentCategories: [],
      previewImage: '',
      previewImage2: '',
      mysort_order: '1',
      new_multipart_params: {
        'key': '',
        'policy': '',
        'OSSAccessKeyId': '',
        'success_action_status': '200',
        'signature': ''
      }
    }
  },
  beforeCreate () {
    ossToken().then(res => {
      this.new_multipart_params = res.multipart_params
      this.actionUrl = res.actionUrl
      console.log('自定义OSS返回的数据：', this.new_multipart_params)
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.loadEditInfo(this.record)
    })
  },
  methods: {
    loadEditInfo (data) {
      const { form } = this
      data.pictures = data.picture
      const formData = pick(data, fields)
      this.id = formData.id
      this.fileList = formData.picture
        ? [{
          url: formData.picture,
          uid: '1',
          name: 'xxx.png',
          status: 'done',
          response: 'Server Error 500'
        }]
        : []
      form.setFieldsValue(formData)
      this.spinning = false
    },
    beforeUpload (file) {
      this.new_multipart_params.key = customUploadFileName(file)
      this.form.setFieldsValue({ picture: this.new_multipart_params.key })
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('你只能上传jpeg/png格式的图片')
      }
      const isLt2M = file.size / 1024 / 1024 < 5
      if (!isLt2M) {
        this.$message.error('文件过大，请重新上传')
      }
      return isJpgOrPng && isLt2M
    },
    // 进口图片
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj, () => {})
      }
      this.previewImage = file.url || file.preview || file.thumbUrl
      this.previewVisible = true
    },
    handleChange ({ fileList, file }) {
      this.fileList = fileList
      if (file.status === 'removed') {
        this.form.setFieldsValue({ picture: '' })
        this.$message.error('请重新上传')
      }
      if (file.status === 'done') {
        this.form.setFieldsValue({ picture: this.actionUrl + '/' + this.new_multipart_params.key })
      }
    },
    handleCancel () {
      this.previewVisible = false
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('提交内容', values)
        if (!err) {
          values.pictures = undefined
          editBanner(values, this.record.id).then((res) => {
            console.log(res, '完成')
            if (res.code === 1000) {
              this.handleGoBack()
            } else {
              this.$message.warning(res.msg)
            }
          })
        }
      })
    },
    handleGoBack () {
      this.$emit('onGoBack')
    }
  }
}
</script>
